<template>
  <v-app>
    <router-view :key="$route.fullPath" />
    <Notification />
    <OverlayLoading />
  </v-app>
</template>

<script>
import {
  SET_IS_ONLINE,
  SET_NOTIFICATION,
  SET_STC,
} from "@/store/mutations.type";
import Notification from "@/layout/Notification";
import OverlayLoading from "@/layout/OverlayLoading";
import { SCREEN } from "@/common/auth.const";
import JwtService from "@/common/jwt.service.js";
import { COMMON_KEYS } from "@/common/constant";

export default {
  name: "App",
  components: {
    Notification,
    OverlayLoading,
  },

  data: () => ({
    isOnline: true,
    isMobile: false,
    wasPressed: false,
  }),
  mounted: function () {
    const vm = this;
    window.addEventListener("load", function () {
      vm.updateOnlineStatus();
      window.addEventListener("online", vm.updateOnlineStatus);
      window.addEventListener("offline", vm.updateOnlineStatus);
    });
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    /*handlerBeforeUnload: function () {
      if (this.wasPressed || performance.navigation.type == performance.navigation.TYPE_RELOAD) {
        return;
      }
    },*/
    updateOnlineStatus: function () {
      if (navigator.onLine) {
        if (!this.isOnline) {
          this.isOnline = true;
          this.$store.commit(SET_IS_ONLINE, true);
          vm.$store.commit(SET_NOTIFICATION, {
            color: "success",
            message: this.$i18n.t("msg.internetConnectionRestore"),
            timeout: 3000,
          });
          this.onConnectionRestore();
        }
      } else {
        this.isOnline = false;
        this.$store.commit(SET_IS_ONLINE, false);
        vm.$store.commit(SET_NOTIFICATION, {
          color: "error",
          message: this.$i18n.t("msg.noInternet"),
          timeout: -1,
        });
      }
    },
    onConnectionRestore() {
      const resultTargetIdOnOffline = JwtService.getCookie(
        COMMON_KEYS.RESULT_TARGET_ID_ON_OFFLINE,
      );
      if (!resultTargetIdOnOffline) {
        return;
      }

      JwtService.deleteCookie(COMMON_KEYS.RESULT_TARGET_ID_ON_OFFLINE);
      // vm.$router.push({
      //   name: SCREEN.TEST_RESULT.NAME,
      //   params: {
      //     id: resultTargetIdOnOffline,
      //   },
      // });
    },
    onResize: function () {
      this.isMobile = window.innerWidth < 770;
      this.$store.commit(SET_STC, window.innerWidth < 860);
    },
    f5key() {
      let e = window.event;
      if ("F5" === e.code) {
        this.wasPressed = true;
      }
    },
  },
  beforeDestroy: function () {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
    window.removeEventListener("resize", this.onResize);
  },
  created() {
    document.onkeydown = this.f5key;
    document.onkeypress = this.f5key;
    document.onkeyup = this.f5key;
    this.onResize();
    window.addEventListener("resize", this.onResize);
    /*document.addEventListener("onbeforeunload", this.handlerBeforeUnload());*/
  },
};
</script>
